module.exports = __webpack_public_path__ + "static/media/TECHNOLOGY.3669bf00.png";